class HelpView {


    constructor() {
        this.helpBtn = $('.app-help');
        this.modal = $('.modal-tips');
        this.tipsCounter = this.modal.find('.tips-counter');
        this.tips = this.modal.find('.tip');
        this.tips.hide();
        this.currentTip = null;
        this.nextTipButton = this.modal.find('.btn-tips');
        this.doneButton = this.modal.find('.tips-done');
    }

    open() {
        this.nextTipButton.show();
        this.modal.modal('show');
        this.tips.hide();
        this.showTip(1);
        $('body').addClass('tips-show');
    }

    close() {
        this.currentTip = null;
        this.modal.modal('hide');
        $('body').removeClass('tips-show');
    }

    showTip(tipNo, animated) {
        animated = falseIfUndefined(animated);
        this.tipsCounter.html('' + tipNo);
        let nextTip = this.modal.find('.tip-no-'+tipNo);

        if(animated && this.currentTip !== null) {
            this.currentTip.fadeOut(
                function() {
                    nextTip.fadeIn();
                    this.currentTip = nextTip;
                }.bind(this)
            );
        } else {
            if(this.currentTip !== null) {
                this.currentTip.hide();
            }
            nextTip.show();
            this.currentTip = nextTip;
        }

        this.nextTipButton.enableIf(tipNo < this.tips.length);
    }
}
